import type { AvailabilityWindow } from "@/components/availability-picker";
import { UsersResponseSchema } from "@/schemas/search";
import type { SearchRequest, UsersResponse } from "@/schemas/search";
import type { ShiftSearchListResponse } from "@/schemas/shift";
import { ShiftSearchListSchemaResponse } from "@/schemas/shift";

import { apiRequest } from "./apiUtils";

function filterValidShifts(parsed: ShiftSearchListResponse) {
  return {
    ...parsed,
    shifts: parsed.shifts.filter(
      (shift) =>
        typeof shift.latitude === "number" &&
        typeof shift.longitude === "number" &&
        !isNaN(shift.latitude) &&
        !isNaN(shift.longitude) &&
        shift.status !== "ASSIGNED",
    ),
  };
}

/** @deprecated Migrate callers to {@link searchShiftsByAvailability}. */
export async function searchShifts(payload: SearchRequest) {
  const data = await apiRequest<ShiftSearchListResponse>(
    `worker/shift/search`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
  const parsed = ShiftSearchListSchemaResponse.parse(data);
  return filterValidShifts(parsed);
}

export type AvailabilityShiftSearchPayload = {
  windows: Array<AvailabilityWindow>;
  location?: { latitude: number; longitude: number };
  distance?: number;
  role_names?: Array<string>;
  business_id?: number;
  page?: number;
  page_size?: number;
};

export async function searchShiftsByAvailability(
  payload: AvailabilityShiftSearchPayload,
) {
  const data = await apiRequest<ShiftSearchListResponse>(
    `worker/shift/availability`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
  const parsed = ShiftSearchListSchemaResponse.parse(data);
  return filterValidShifts(parsed);
}

export type PostWorkerAvailabilityPayload = {
  role_names: Array<string>;
  windows: Array<AvailabilityWindow>;
};

export async function postWorkerAvailability(
  payload: PostWorkerAvailabilityPayload,
): Promise<{ success: boolean }> {
  const data = await apiRequest<{ success: boolean }>(`worker/availability`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data;
}

export async function searchWorkers(payload: SearchRequest) {
  const data = await apiRequest<UsersResponse>(`business/shift/worker-search`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return UsersResponseSchema.parse(data);
}
